import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import ShortAndLong from './pages/ShortAndLong';
import DBMonitor from './pages/DBMonitor';
import ServerMonitor from './pages/ServerMonitor';
import SP500Market from './pages/SP500Market';
import SP500PreMarket from './pages/SP500PreMarket';
import Options from './pages/Options';
import { isTokenExpired } from './utils/auth';

function NotFoundRedirect() {
  const token = localStorage.getItem('token');
  const loggedIn = token && !isTokenExpired(token);
  return <Navigate to={loggedIn ? '/dashboard' : '/'} replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/short-and-long" element={<ShortAndLong />} />
          <Route path="/sp500-premarket" element={<SP500PreMarket />} />
          <Route path="/sp500-market" element={<SP500Market />} />
          <Route path="/options" element={<Options />} />
          <Route path="/monitor/db" element={<DBMonitor />} />
          <Route path="/monitor/server" element={<ServerMonitor />} />
        </Route>
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
